import type { MissionStatus } from '@flipster/apis/v1/rewardHub/types';

import claimable1CoinIcon from '../../../assets/images/multiple-coin-icon/claimable1.webp';
import claimable2CoinIcon from '../../../assets/images/multiple-coin-icon/claimable2.webp';
import claimable3CoinIcon from '../../../assets/images/multiple-coin-icon/claimable3.webp';
import claimed1CoinIcon from '../../../assets/images/multiple-coin-icon/claimed1.webp';
import claimed2CoinIcon from '../../../assets/images/multiple-coin-icon/claimed2.webp';
import claimed3CoinIcon from '../../../assets/images/multiple-coin-icon/claimed3.webp';
import defaultNotSelected1CoinIcon from '../../../assets/images/multiple-coin-icon/default-not-selected1.webp';
import defaultNotSelected2CoinIcon from '../../../assets/images/multiple-coin-icon/default-not-selected2.webp';
import defaultNotSelected3CoinIcon from '../../../assets/images/multiple-coin-icon/default-not-selected3.webp';
import defaultSelected1CoinIcon from '../../../assets/images/multiple-coin-icon/default-selected1.webp';
import defaultSelected2CoinIcon from '../../../assets/images/multiple-coin-icon/default-selected2.webp';
import defaultSelected3CoinIcon from '../../../assets/images/multiple-coin-icon/default-selected3.webp';
import disabled1CoinIcon from '../../../assets/images/multiple-coin-icon/disabled1.webp';
import disabled2CoinIcon from '../../../assets/images/multiple-coin-icon/disabled2.webp';
import disabled3CoinIcon from '../../../assets/images/multiple-coin-icon/disabled3.webp';
import { getMissionStatusFlags } from '../../utils';

export type MissionCoinIconType = 'disabled' | 'claimed' | 'claimable' | 'default-selected' | 'default-not-selected';

export interface MissionCoinIconConfig {
  selectedType: MissionCoinIconType;
  notSelectedType: MissionCoinIconType;
  selectedTextColor: string;
  notSelectedTextColor: string;
}

export const getMissionCoinIconConfig = (status: MissionStatus | undefined): MissionCoinIconConfig => {
  const { isExpired, isRejected, isClaimed, isSettled, isClaimable } = getMissionStatusFlags(status);

  if (isExpired || isRejected) {
    return {
      selectedType: 'disabled',
      notSelectedType: 'disabled',
      selectedTextColor: 'content.default.level-1',
      notSelectedTextColor: 'content.default.level-1',
    };
  }
  if (isClaimed || isSettled) {
    return {
      selectedType: 'claimed',
      notSelectedType: 'default-not-selected',
      selectedTextColor: 'content.default.level-1',
      notSelectedTextColor: 'content.default.level-1',
    };
  }
  if (isClaimable) {
    return {
      selectedType: 'claimable',
      notSelectedType: 'default-not-selected',
      selectedTextColor: 'content.accent.promotion',
      notSelectedTextColor: 'content.default.level-5',
    };
  }
  return {
    selectedType: 'default-selected',
    notSelectedType: 'default-not-selected',
    selectedTextColor: 'content.accent.promotion',
    notSelectedTextColor: 'content.default.level-5',
  };
};

const coinIconsMap: Record<MissionCoinIconType, { src: string }[]> = {
  disabled: [disabled1CoinIcon, disabled2CoinIcon, disabled3CoinIcon],
  claimed: [claimed1CoinIcon, claimed2CoinIcon, claimed3CoinIcon],
  claimable: [claimable1CoinIcon, claimable2CoinIcon, claimable3CoinIcon],
  'default-selected': [defaultSelected1CoinIcon, defaultSelected2CoinIcon, defaultSelected3CoinIcon],
  'default-not-selected': [defaultNotSelected1CoinIcon, defaultNotSelected2CoinIcon, defaultNotSelected3CoinIcon],
};

export const getCoinIconSrc = (type: MissionCoinIconType, tier: 1 | 2 | 3): string => {
  const list = coinIconsMap[type];
  return list?.[tier - 1]?.src ?? defaultSelected1CoinIcon.src;
};
